import { SelectorObj } from '../../shared.types'
import { getVariantSelectors } from '../../utils/variantsUtils'
import { DomApplier } from '../cssFeatures.types'

export const variablesDomApplier: DomApplier<'variables'> = (
	{ id: compId },
	idSelector,
	breakpointId,
	{ variables, variablesVariants },
	accumulatedData
) => {
	const variablesInBreakpoint = variables?.[breakpointId]
	if (!variablesInBreakpoint) {
		return null
	}

	const acc: SelectorObj = {}

	for (const variantKey in variablesInBreakpoint) {
		const variantSelectors = variablesVariants
			? getVariantSelectors(variantKey, variablesVariants, compId, accumulatedData)
			: ['']
		const cssObj = variablesInBreakpoint[variantKey]
		const domSelector = variantSelectors.join(',')
		acc[domSelector] = Object.assign(acc[domSelector] || {}, cssObj)
	}

	return acc
}
